import { c as _c } from "react/compiler-runtime";
import { addFeedback, getFeedback } from "@/features/engagement/actions/feedback";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
export function useFeedback(slug) {
  const $ = _c(2);
  let t0;
  if ($[0] !== slug) {
    t0 = {
      queryKey: ["feedback", slug],
      queryFn: () => getFeedback(slug)
    };
    $[0] = slug;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
}
export function useAddFeedback(slug) {
  const $ = _c(10);
  const queryClient = useQueryClient();
  let t0;
  let t1;
  if ($[0] !== slug) {
    t0 = ["feedback", slug];
    t1 = formData => addFeedback(formData, slug);
    $[0] = slug;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== queryClient || $[4] !== slug) {
    t2 = () => {
      queryClient.invalidateQueries({
        queryKey: ["feedback", slug]
      });
    };
    $[3] = queryClient;
    $[4] = slug;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = {
      mutationKey: t0,
      mutationFn: t1,
      onSuccess: t2
    };
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return useMutation(t3);
}